import { AfterViewInit, Directive, ElementRef, Input, OnInit } from '@angular/core';
import * as anime from 'animejs/lib/anime';

@Directive({
  selector: '[ring]',
  exportAs: 'synRing'
})
export class RingDirective implements OnInit, AfterViewInit {
  @Input() private animeStrength: number = 30;
  @Input() private autoplay: boolean = true;
  private animation: any;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.animation = anime({
      targets: [this.el.nativeElement],
      easing: 'easeInOutSine',
      duration: 550,
      rotate: [
        {
          value: this.animeStrength * -1,
        },
        {
          value: this.animeStrength,
        },
        {
          value: this.animeStrength / -1,
        },
        {
          value: this.animeStrength,
        },
        {
          value: 0
        }
      ]
    });
  }

  public ngAfterViewInit() {
    if (this.autoplay) {
      setTimeout(() => { // Hack. Je pense que c'est pcq l'image est pas encore chargé que l'animation ne se provoque pas au démarrage.. A creuser !       
      
        this.animation.play()
    }, 500);
    }
  }

  public play() {
    this.animation.play();
  }
}